import createCache from "@emotion/cache";

// Shared by the browser (_app's session-wide cache) and the server
// (getEmotionDocumentInitialProps' per-request cache).
//
// Both sides must build an identical cache: the class name hash and the
// data-emotion key derive from this config, so if they diverged the client
// would not recognise the server's <style> tags as its own, would re-inject
// duplicates, and specificity could shift.
//
// prepend: true puts MUI styles at the top of <head> so styles.scss and other
// plain CSS still win on equal specificity, on the server as well as the client.
export function createEmotionCache() {
  return createCache({ key: "css", prepend: true });
}
